import { useContext, useEffect } from "react";
import { useParams } from "react-router-dom";
import { UserContext } from "../contexts/user";
import { getReportInfo360 } from "../axios/axiosFunctions";
import { Box, Grid, Typography } from "@mui/material";
import { useState } from "react";
import Chart360 from "./Chart360";

const BlockReport360 = ({blockId,name,slug,color,info,onBlock360DataReady,reportUserId}) => {

    const {groupId} = useParams();
    const {currentUser} = useContext(UserContext);
    const [questions, setQuestions] = useState([]);
    const [currentBlockText, setCurrentBlockText] = useState("");

    // Use reportUserId (admin preview) if available, otherwise currentUser
    const effectiveUserId = reportUserId || currentUser._id;

    useEffect(() => {
        const callInfo = async()=>{
            const res = await getReportInfo360(effectiveUserId,groupId,blockId,slug);
            if(res){
                const ownerQ = res.data.pop();
                const data = res.data.map((question,i)=>({
                    manager: Number(question.managerValue ?? question.positivePercentageM),
                    direct: Number(question.directValue ?? question.positivePercentageD),
                    peer: Number(question.peerValue ?? question.positivePercentageP),
                    otherColleague: Number(question.otherColleagueValue ?? 0),
                    question: question.text,
                    owner: findQuestion(ownerQ.ownerAnswers[i])
                }));
                setQuestions(data);
                // Pass raw data to parent for PDF generation (no image needed)
                if (onBlock360DataReady) {
                    onBlock360DataReady(data);
                }
            }
        }
        callInfo();
    }, []);

    useEffect(() => {
        const infoBlock = info.find((b)=>b.block === blockId);
        setCurrentBlockText(infoBlock?.text || "");
    }, [blockId,info]);

    const findQuestion = (ownerQ)=>{
        const answer = ownerQ.answer;
        const mapAnswer= {
            "unable": 0,
            "notConfident":25,
            "somewhat": 50,
            "confident": 75,
            "very":100
        };
        return mapAnswer[answer] || 0;
    }

    return (
    <Box display="flex" flexDirection="column" sx={{padding:{xs:"0px 16px",sm:"0px 24px",md:"0px 48px"}}}>
        <Grid container spacing={2} sx={{margin:"32px 0px 40px 0px"}}>
            <Grid size={12}>
                <Typography variant="body1" fontWeight={400} sx={{marginTop:"4px",lineHeight:"1.7",fontSize:"1.05rem",whiteSpace:"pre-wrap"}}>{currentBlockText}</Typography>
                <Typography variant="body1" color="text.secondary" sx={{ marginTop: "12px", fontSize:"1.05rem", lineHeight:"1.7" }}>
                    Review the responses on all 10 questions. Then identify your priority areas of focus. Note: If a line is blank that means fewer than 3 people were able to respond to your question.
                </Typography>
            </Grid>
            <Grid size={12}>
                {
                    questions && questions.length !== 0 && questions.map((q,i)=>(
                    <Chart360 key={i} index={i} color={color} question={q.question} values={[q.owner,q.manager,q.direct,q.peer,q.otherColleague]} labels={["Self","Manager","Direct","Peer","Other"]}/>
                    ))
                }
            </Grid>
        </Grid>
    </Box>
    )
}

export default BlockReport360